import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DRangosArt241ET } from "@dian-api/renta210v18";
import { DBasicosParametricasServicios, DValorPeriodico} from "@dian/api-basicos-parametricas";

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_547';

const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;
declare var require: (filename: string) => any;

var BigNumber210 = require("bignumber.js");

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Acciones', listHelp: ['481'] },
 /*  { text: "2", active: false, completed: false, tooltip: 'Costo fiscal inmuebles exterior', listHelp: ['cas1', 'cas2'] },
  { text: "3", active: false, completed: false, tooltip: 'Datos inmuebles exterior', listHelp: ['cas1', 'cas2'] },
  { text: "4", active: false, completed: false, tooltip: 'Inmueble nacional', listHelp: ['cas1', 'cas2'] },
  { text: "5", active: false, completed: false, tooltip: 'Datos nacional', listHelp: ['cas1', 'cas2'] } */
];

const tableStructure = [
  {id: 'desc', title: 'Descripción'}, 
  {id: 'valVenta', title: 'Valor'}
 
];

class Form1 {
  id: number;
  desc: string; //descripcion
  valVenta: number; //valor venta
  valCompra: number; //valor compra
  anioCompra: number; //anio compra
  valImpuestoPag: number; //valor impuesto pagado exterior
  ubicacion: number; //ubicacion accion
  ubicacionDes: string;
  impuestoCalcColombia: number;
  limitanteImpuestoExterior: number;
  UtilidadBVC: number;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-renta-no-laboral-acciones-modal',
  templateUrl: './renta-no-laboral-acciones-modal.component.html',
  styleUrls: ['./renta-no-laboral-acciones-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios
  ]
})
export class RentaNoLaboralAccionesModalComponent extends HandlerModal implements OnInit {
  saveModel = new EventEmitter();
  showSave:boolean=false;
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstUbicaciones: ArticulosDominio[] = [];
  public lsValoresCostos: ArticulosDominio[] = [];
  public lstAnios:  ArticulosDominio[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  private rangosArt241ET: any;
  public UVT: string = "38004";
  
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<RentaNoLaboralAccionesModalComponent>,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1;
    this.obtenerValorPeriodico110();
    this.initializeArticulos();
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.validateShowSave();
    this.initializeAnios();
    this.dataSourceBody.length > 0?this.operacionCs483():'';
    

  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valCompra=0;
    this.modelForm.anioCompra=0;
    this.modelForm.valVenta=0;
    this.modelForm.valImpuestoPag=0;
    this.modelForm.ubicacion=0;
    this.modelForm.impuestoCalcColombia=0;
    this.modelForm.limitanteImpuestoExterior=0;
    this.modelForm.UtilidadBVC=0;


  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_895 == undefined){
      this.model.doc.cuerpo.cc_id_895 = [];
      this.model.doc.cuerpo.cs_id_483 = "0";
      this.model.doc.cuerpo.cs_id_485 = "0";
      this.model.doc.cuerpo.cs_id_538  = "0";
      this.model.doc.cuerpo.cs_id_679 = "0";

    }  if(this.model.doc.cuerpo.cc_id_888 == undefined) 
      this.model.doc.cuerpo.cc_id_888 = [];
      if(this.model.doc.cuerpo.cc_id_890 == undefined) 
      this.model.doc.cuerpo.cc_id_890 = [];
      if(this.model.doc.cuerpo.cc_id_893 == undefined) 
      this.model.doc.cuerpo.cc_id_893 = [];
      if(this.model.doc.cuerpo.cc_id_894 == undefined) 
      this.model.doc.cuerpo.cc_id_894 = [];
      if(this.model.doc.cuerpo.cc_id_889 == undefined) 
      this.model.doc.cuerpo.cc_id_889 = [];
      if(this.model.doc.cuerpo.cc_id_891 == undefined) 
      this.model.doc.cuerpo.cc_id_891 = [];
      if(this.model.doc.cuerpo.cc_id_892 == undefined) 
      this.model.doc.cuerpo.cc_id_892 = [];
      if(this.model.doc.cuerpo.cc_id_900 == undefined) 
      this.model.doc.cuerpo.cc_id_900 = [];
  
  /*
  891	Impuesto calculado en Colombia
  892	Limitante Impuesto pagado en el exterior
  900	Utilidad acciones BVC
  */
  }

  protected initializeArticulos(){
    this.lstArticulos[0] = {valor:1,nombre:"Valor Catastral"};
    this.lstArticulos[1] = {valor:2,nombre:"Valor Articulo 70"};
    this.lstArticulos[2] = {valor:3,nombre:"Valor Articulo 73"};

    this.lstUbicaciones[0] = {valor:1,nombre:"BVC"};
    this.lstUbicaciones[1] = {valor:2,nombre:"Exterior"};
    this.lstUbicaciones[2] = {valor:3,nombre:"Colombia Otro "};
  }
  protected initializeAnios(){
    this.lstAnios[0] = {valor:0,nombre:"2020"};
    this.lstAnios[1] = {valor:1,nombre:"2021"};
    this.lstAnios[2] = {valor:2,nombre:"2022"};

  }

  public operacionCs483(){
    let suma1 = "0";
    let suma2 = "0";
    let suma3 = "0";
    let suma4 = "0";
  
    for(let i=0; i<this.dataSourceBody.length; i++){
      suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,""+this.dataSourceBody[i].valVenta,suma1);
      suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,""+this.dataSourceBody[i].valCompra,suma2);
      
      

      //calculos impuestoCalcColombia
      const cas888 = ""+this.dataSourceBody[i].valVenta;
      const cas893 = ""+this.dataSourceBody[i].valCompra;
      const cas890 = ""+this.dataSourceBody[i].valImpuestoPag;
     
     

     let base = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,cas888,cas893);
     base = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,base,"0")?"0":base;
     const valorEnUvt = this.convertirPesosUvt(base);
     const  cas900 = base;
     if (this.dataSourceBody[i].ubicacion == 2){
     let resultado = this.aplicarTablaArt241ET(
       valorEnUvt,
       this.rangosArt241ET
     );

   
     resultado = this.dutilidades.redondearValorMoneda(resultado, true);
     //////////////////////////////////////////////////////
     this.dataSourceBody[i].impuestoCalcColombia=resultado; //////casila891

     const cas891 = ""+this.dataSourceBody[i].impuestoCalcColombia;
     
     if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas890,cas891) )
     {
      this.dataSourceBody[i].limitanteImpuestoExterior=cas890;
      suma4 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,cas890,suma4); 

     }
     else
     {
      this.dataSourceBody[i].limitanteImpuestoExterior=cas891;
      suma4 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,cas891,suma4); 
     }

    }
      if(this.dataSourceBody[i].ubicacion==1)
      {
        this.dataSourceBody[i].UtilidadBVC=cas900;
        this.dataSourceBody[i].ubicacionDes="BVC";
        suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,cas900,suma3);
     
      }
     
    }
    
    this.model.doc.cuerpo.cs_id_483 = suma1;
    this.model.doc.cuerpo.cs_id_485 = suma2;
    this.model.doc.cuerpo.cs_id_538 = suma3;
    this.model.doc.cuerpo.cs_id_679 = suma4;
   
  }
 

  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_894.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_895[i].v;
      this.modelForm.valCompra=this.model.doc.cuerpo.cc_id_893[i].v;
      this.modelForm.valVenta=this.model.doc.cuerpo.cc_id_888[i].v;
      this.modelForm.anioCompra=this.model.doc.cuerpo.cc_id_894[i].v;
      this.modelForm.valImpuestoPag=this.model.doc.cuerpo.cc_id_890[i].v;
      this.modelForm.ubicacion=this.model.doc.cuerpo.cc_id_889[i].v;
      this.modelForm.impuestoCalcColombia=this.model.doc.cuerpo.cc_id_891[i].v;
      this.modelForm.limitanteImpuestoExterior=this.model.doc.cuerpo.cc_id_892[i].v;
      this.modelForm.UtilidadBVC=this.model.doc.cuerpo.cc_id_900[i].v;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();          
    }
  }

  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_895[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_888[this.modelForm.id].v=this.modelForm.valVenta.toString();;
    this.model.doc.cuerpo.cc_id_890[this.modelForm.id].v=this.modelForm.valImpuestoPag.toString();
    this.model.doc.cuerpo.cc_id_893[this.modelForm.id].v=this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_894[this.modelForm.id].v=this.modelForm.anioCompra.toString();
    this.model.doc.cuerpo.cc_id_889[this.modelForm.id].v=this.modelForm.ubicacion.toString();
    this.model.doc.cuerpo.cc_id_891[this.modelForm.id].v=this.modelForm.impuestoCalcColombia.toString();
    this.model.doc.cuerpo.cc_id_892[this.modelForm.id].v=this.modelForm.limitanteImpuestoExterior.toString();
    this.model.doc.cuerpo.cc_id_900[this.modelForm.id].v=this.modelForm.UtilidadBVC.toString();


  
  }

  public addToModeloDesdeForm(){
    let i=this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_895.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_888.push({it: i, v:this.modelForm.valVenta.toString()});
    this.model.doc.cuerpo.cc_id_890.push({it: i, v:this.modelForm.valImpuestoPag.toString()});
    this.model.doc.cuerpo.cc_id_893.push({it: i, v:this.modelForm.valCompra.toString()});
    this.model.doc.cuerpo.cc_id_894.push({it: i, v:this.modelForm.anioCompra.toString()});
    this.model.doc.cuerpo.cc_id_889.push({it: i, v:this.modelForm.ubicacion.toString()});
    this.model.doc.cuerpo.cc_id_891.push({it: i, v:this.modelForm.impuestoCalcColombia.toString()});
    this.model.doc.cuerpo.cc_id_892.push({it: i, v:this.modelForm.limitanteImpuestoExterior.toString()});
    this.model.doc.cuerpo.cc_id_900.push({it: i, v:this.modelForm.UtilidadBVC.toString()});

 
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_895.splice(index,1);
    this.model.doc.cuerpo.cc_id_888.splice(index,1);
    this.model.doc.cuerpo.cc_id_890.splice(index,1);
    this.model.doc.cuerpo.cc_id_893.splice(index,1);
    this.model.doc.cuerpo.cc_id_894.splice(index,1);
    this.model.doc.cuerpo.cc_id_889.splice(index,1);
    this.model.doc.cuerpo.cc_id_891.splice(index,1);
    this.model.doc.cuerpo.cc_id_892.splice(index,1);
    this.model.doc.cuerpo.cc_id_900.splice(index,1);

    

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_894.length;i++){
      this.model.doc.cuerpo.cc_id_895[i].it=i+1;
      this.model.doc.cuerpo.cc_id_888[i].it=i+1;
      this.model.doc.cuerpo.cc_id_890[i].it=i+1;
      this.model.doc.cuerpo.cc_id_893[i].it=i+1;
      this.model.doc.cuerpo.cc_id_894[i].it=i+1;
      this.model.doc.cuerpo.cc_id_889[i].it=i+1;
      this.model.doc.cuerpo.cc_id_891[i].it=i+1;
      this.model.doc.cuerpo.cc_id_892[i].it=i+1;
      this.model.doc.cuerpo.cc_id_900[i].it=i+1;

      
    }
  }

  public validateFormCompleted():boolean{
    return (this.modelForm.desc==undefined || this.modelForm.desc=="" ||
    this.modelForm.valVenta==undefined || this.modelForm.valVenta==0 ||
        this.modelForm.valCompra==undefined || this.modelForm.valCompra==0 || 
        this.modelForm.anioCompra==undefined || this.modelForm.anioCompra==0 ||        
        this.modelForm.ubicacion==undefined || this.modelForm.ubicacion==0 ||
        this.modelForm.ubicacion==undefined || this.modelForm.ubicacion==0||
        ( this.modelForm.ubicacion == 2  && this.modelForm.valImpuestoPag == 0  )
    );
       

  }

  public redondearFormData(){
    this.modelForm.valVenta=Number(this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString()));
    this.modelForm.valCompra=Number(this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString()));
    this.modelForm.valImpuestoPag=Number(this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoPag.toString()));

  }

  public calcularValoresForm(){
   //////////////////////////////////TODO Calculos /////////////////
   console.log(this.modelForm);
    this.redondearFormData();
   // const cas879 = this.modelForm.valVenta.toString();
  
   ///////////////////////////////////////////////////////
  }

  public onChangeUbicacion(){
    if(this.modelForm.ubicacion!=2){
      this.modelForm.valImpuestoPag = 0;
    }
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs483();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs483();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }


  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ 
      this.showSave=true 
    };
  }
   /**
    * @desc Funcion para obtener los valores del modelo e operar con ellos
    * @param {DTipoOperacionAritmetica} operacion
    * @param {DDocumento} modelo
    * @param {Array<string>} campos
    * @param {boolean} formatear
    * @return {String}
    */
    protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
      let valores = [];
      for (let i in campos) {
          if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
              let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
              valores.push(valor);
              //valores.push(modelo.doc.cuerpo[campos[i]]);
          } else {
              valores.push('0');
          }
      }
      return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }
  //UVT 
  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION).subscribe(
      data => this.setObjectFromResponse(data),
      error => console.log(error)
    )
  }
  private setObjectFromResponse(data: any): void {
    
        let model=<DValorPeriodico>data;
        this.UVT = String(model.valor);
     
  }

  private aplicarTablaArt241ET(baseGravable, rangos) {
    let desde: boolean = false;

    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(
        DTipoOperacionAritmetica.MAYOR_QUE,
        baseGravable,
        rangos[i].desde
      );

      if (i + 1 < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(
          DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,
          baseGravable,
          rangos[i + 1].desde
        );
      } else {
        hasta = true;
      }

      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.RESTA,
          baseGravable,
          rangos[i].desde
        );

        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.MULTIPLICACION,
          resultadoResta,
          rangos[i].tarifa
        );

        const punto = resultadoMultiplicacion.indexOf(".");

        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(
            0,
            punto + 3
          );
        }

        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.SUMA,
          resultadoMultiplicacion,
          rangos[i].impuesto
        );

        const resultadoOperacion = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.MULTIPLICACION,
          resultadoSuma2,
          this.UVT
        );

        return resultadoOperacion;
      }
    }

    return "0";
  }
  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);

    let valorOperacion = new BigNumber210(valorPesos);

    valorOperacion = valorOperacion.div(this.UVT);

    valorOperacion = valorOperacion.toFormat();

    const punto = valorOperacion.indexOf(".") + 1;

    if (punto > 0 && valorOperacion.length - punto > 2)
      valorOperacion = valorOperacion.slice(0, -1);

    return String(valorOperacion);
  }
  
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-acciones-modal/renta-no-laboral-acciones-modal.component.ts